import { IDay } from './types'

export function setInitialCalendarValues(days: IDay[]) {
  return {
    type: '@calendarGoal/SET_INITIAL_CALENDAR_VALUES',
    payload: { days }
  }
}

export function clearCalendarGoalRedux() {
  return {
    type: '@calendarGoal/CLEAR_REDUX'
  }
}
